<template>
    <div class="bg-white rounded">
        <div class="flex items-center justify-between px-4 pt-2 pb-1">
            <div class="leading-none">
                <p class="font-semibold text-lg lg:text-2xl">{{ title }}</p>
                <span class="text-xs text-gray-400 uppercase">{{ subtitle }}</span>
            </div>
            <slot />
        </div>
        <apexcharts height="50px" :options="chartOptions" :series="chartSeries"></apexcharts>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['title', 'subtitle', 'color', 'options'],
    components: {
        apexcharts: VueApexCharts
    },
    data: function() {
        return {
            chartOptions: {
                chart: {
                    type: 'area',
                    sparkline: {
                        enabled: true,
                    },
                },
                fill: {
                    // gradient: {
                    //     // stops: [20, 50, 60]
                    //     opacityFrom: 0.8,
                    //     opacityTo: 0.7,
                    // }
                    type: 'solid',
                    // colors: '#E5E7EB',
                    opacity: 0.03
                },
                colors: [this.color],
                labels: this.options.labels,
                stroke: {
                    curve: this.options.curve,
                    width: 1
                },
                yaxis: {
                    // min: 0,
                }
            },
            chartSeries: [
                {
                    name: this.subtitle,
                    data: this.options.data,
                },
            ],
        }
    }
}
</script>

<style>

</style>